import MerchCategories from './MerchCategories';

export default MerchCategories;
